import apiClient from "@/axios";

export const getLastUpdated = async () => {
  const response = await apiClient.post("/user/statistic/get-last-updated");
  return response;
};

export const getLastPublished = async () => {
  const response = await apiClient.post("/user/statistic/get-last-published");
  return response;
};
export const getTopApps = async () => {
  const response = await apiClient.post("/user/statistic/top-apps");
  return response;
};

export const getTopDevelopers = async () => {
  const response = await apiClient.post("/user/statistic/top-developers");
  return response;
};

export const getUserStatistic = async () => {
  const response = await apiClient.post("/user/statistic/get-statistic");
  return response;
};